import React, { useState, useEffect } from 'react';
import Wrapper from '../../Main/Universal/Wrapper';
import SendEmail from './SendEmail';
import SendSMS from './SendSMS';
import CreateGroupemail from './CreateGroupemail';
import EmailList from './EmailList';
import MailLog from './MailLog';
import SMSLog from './SMSLog';

const BulkEmail = () => {
    return (
        <Wrapper>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <h3 className='mb-3'>Bulk Email / SMS</h3>
                    </div>
                </div>
                <ul class="nav nav-tabs home-tabs mb-3" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="group-list-tab" data-bs-toggle="tab" data-bs-target="#group-list" type="button" role="tab" aria-controls="group-list" aria-selected="true">Group list</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="group-create-tab" data-bs-toggle="tab" data-bs-target="#group-create" type="button" role="tab" aria-controls="group-create" aria-selected="true">Create group</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="mail-log-section-tab" data-bs-toggle="tab" data-bs-target="#mail-log-section" type="button" role="tab" aria-controls="mail-log-section" aria-selected="false">Mail Log</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="send-email-section-tab" data-bs-toggle="tab" data-bs-target="#send-email-section" type="button" role="tab" aria-controls="send-email-section" aria-selected="false">Send email</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="sms-log-section-tab" data-bs-toggle="tab" data-bs-target="#sms-log-section" type="button" role="tab" aria-controls="sms-log-section" aria-selected="false">SMS Log</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="send-sms-section-tab" data-bs-toggle="tab" data-bs-target="#send-sms-section" type="button" role="tab" aria-controls="send-sms-section" aria-selected="false">Send SMS</button>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="group-list" role="tabpanel" aria-labelledby="group-list-tab">
                        <EmailList />
                    </div>
                    <div class="tab-pane fade show" id="group-create" role="tabpanel" aria-labelledby="group-create-tab">
                        <CreateGroupemail />
                    </div>
                    <div class="tab-pane fade show" id="mail-log-section" role="tabpanel" aria-labelledby="mail-log-section-tab">
                        <MailLog />
                    </div>
                    <div class="tab-pane fade show" id="send-email-section" role="tabpanel" aria-labelledby="send-email-section-tab">
                        <SendEmail />
                    </div>
                    <div class="tab-pane fade show" id="send-sms-section" role="tabpanel" aria-labelledby="send-sms-section-tab">
                        <SendSMS />
                    </div>
                    <div class="tab-pane fade show" id="sms-log-section" role="tabpanel" aria-labelledby="sms-log-section-tab">
                        <SMSLog />
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

export default BulkEmail